import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Modal } from 'bootstrap';

import './DeveloperDocs.css';

const DeveloperDocs = () => {
  const [showDevSupportModal, setShowDevSupportModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
   const [devSupportFormData, setDevSupportFormData] = useState({
    username: '',
    email: '',
    description: ''
  });
    useEffect(() => {
    // Preloader
      $(window).on('load', function () {
          $('.preloader').delay(1000).fadeOut(1000);
        });
        setTimeout(() => {
          $('.preloader').fadeOut(1000);
        }, 2000);
  });
 // Reset form when modal is closed
  useEffect(() => {
    const modal = document.getElementById('exampleModal');
    if (modal) {
      modal.addEventListener('hidden.bs.modal', () => {
        setDevSupportFormData({
          username: '',
          email: '',
          description: ''
        });
      });
    }

    return () => {
      if (modal) {
        modal.removeEventListener('hidden.bs.modal', () => {});
      }
    };
  }, []);

  const handleDevSupportSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...devSupportFormData,
          subject: 'Developer Support Request - Feedmex API'
        }),
      });

      if (response.ok) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Support request sent successfully!',
          showConfirmButton: false,
          timer: 2000
        });
        setDevSupportFormData({
          username: '',
          email: '',
          description: ''
        });
      } else {
        const errorResponse = await response.text();
        let errorMessage;
        try {
          const jsonResponse = JSON.parse(errorResponse);
          errorMessage = jsonResponse.message;
        } catch (e) {
          errorMessage = 'An unknown error occurred';
        }
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `Failed to send request: ${errorMessage}`,
          showConfirmButton: true
        });
      }
    } catch (error) {
      console.error('Error sending support request:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'An error occurred. Please try again later.',
        showConfirmButton: true
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDevSupportInputChange = (e) => {
    const { name, value } = e.target;
    setDevSupportFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <>
        <Header />
      <div className="container-fluid about-us-container">
        <div className="preloader">
          <div className="frame">
            <div className="center">
              <div className="dot-1"></div>
              <div className="dot-2"></div>
            </div>
          </div>
        </div>      

       <section id="about-us-page" className="about-us-section">
            <div className="container zindex">
            <div className="docs-header text-center">
              <h3>Clean APIs. <span className="highlight">Built for Integration.</span></h3>
              <p className="subheader">Connect Feedmex to any POS system or front-end environment</p>
            </div>

            <div className="row docs-overview">
              <div className="col-lg-12">
                <div className="docs-card">
                  <h3 className='mb-2' >Overview</h3>
                  <p>Feedmex's API lets you collect and manage customer Refmex from any POS system or front-end environment. It's RESTful, secure, and comes with straightforward authentication and payload structures.</p>
                  
                  <div className="key-features mt-4">
                    <h5 className='mb-2'  >Key Features</h5>
                    <ul>
                      <li><i className="fa fa-check-circle-o check-style" aria-hidden="true"></i> Simple REST endpoints</li>
                      <li><i className="fa fa-check-circle-o check-style" aria-hidden="true"></i> JSON request/response formats</li>
                      <li><i className="fa fa-check-circle-o check-style" aria-hidden="true"></i> Webhook support for Refmex events</li>
                      <li><i className="fa fa-check-circle-o check-style" aria-hidden="true"></i> API keys with role-based scopes</li>
                      <li><i className="fa fa-check-circle-o check-style" aria-hidden="true"></i> Sandbox environment available</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="row endpoints-section">
              <div className="col-lg-12">
                <div className="docs-card">
                  <h3>Core Endpoints</h3>
                  
                  <div className="endpoint-item">
                    <h5>POST /api/v1/Refmex</h5>
                    <p>Submit customer Refmex</p>
                    <div className="code-badge">Refmex Submission</div>
                  </div>
                  
                  <div className="endpoint-item">
                    <h5>GET /api/v1/forms</h5>
                    <p>Retrieve form templates</p>
                    <div className="code-badge">Form Management</div>
                  </div>
                  
                  <div className="endpoint-item">
                    <h5>POST /api/v1/forms/custom</h5>
                    <p>Create a custom form</p>
                    <div className="code-badge">Form Management</div>
                  </div>
                  
                  <div className="endpoint-item">
                    <h5>GET /api/v1/analytics</h5>
                    <p>Fetch response analytics</p>
                    <div className="code-badge">Data Analytics</div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className="row auth-section">
              <div className="col-lg-12">
                <div className="docs-card">
                  <h3>Authentication</h3>
                  <p>All API requests require a bearer token. Tokens can be generated in the dashboard.</p>
                  
                  <div className="code-sample">
                    <h5>Code Sample (cURL)</h5>
                    <pre>
                        {`curl -X POST https://api.feedmex.com/v1/Refmex \\
                        -H "Authorization: Bearer YOUR_API_KEY" \\
                        -H "Content-Type: application/json" \\
                        -d '{
                          "form_id": "abc123",
                          "responses": {
                            "q1": 5,
                            "q2": "Service was great.",
                            "q3": "Yes"
                          }
                        }'`}
                    </pre>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="row start-building">
              <div className="col-lg-12 text-center">
                <div className="cta-buttons">
                  <a href="/ApiDocumentation" className="bor">
                    <i className="fa fa-file-text-o" aria-hidden="true"></i> Read the Full API Docs
                  </a>
                  {/* <a href="#" className="bor">
                    <i className="fa fa-code" aria-hidden="true"></i> Access Sandbox Environment
                  </a> */}
                  <a href="#" className="bor"  data-toggle="modal" data-target="#exampleModal">
                    <i className="fa fa-envelope-o" aria-hidden="true"></i> Get Developer Support
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>



        {/* Developer Support Modal */}
        <div className={`modal fade ${showDevSupportModal ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" 
          style={{ display: showDevSupportModal ? 'block' : 'none', backgroundColor: showDevSupportModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Developer Support Request</h5>
                {/* <button type="button" className="close" onClick={() => setShowDevSupportModal(false)} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button> */}
              </div>
              <form onSubmit={handleDevSupportSubmit}>
                <div className="modal-body">
                  <div className="input-group contact-input mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text faq-icon">
                        <i className="fa fa-user-o" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      name="username"
                      className="form-control box-bg"
                      placeholder="Your Name"
                      value={devSupportFormData.username}
                      onChange={handleDevSupportInputChange}
                      required
                    />
                  </div>
                  
                  <div className="input-group contact-input mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text faq-icon">
                        <i className="fa fa-envelope-o" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      type="email"
                      name="email"
                      className="form-control box-bg"
                      placeholder="Your Email"
                      value={devSupportFormData.email}
                      onChange={handleDevSupportInputChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    {/* <label>Your Question or Issue</label> */}
                    <textarea
                      name="description"
                      className="form-control box-bg"
                      placeholder="Describe your issue or question in detail"
                      rows="3"
                      value={devSupportFormData.description}
                      onChange={handleDevSupportInputChange}
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  {/* <button 
                    type="button" 
                    className="dropboxx" 
                    onClick={() => setShowDevSupportModal(false)}
                  >
                    Cancel
                  </button> */}
                  <button
                    type="submit"
                    className="dropboxx2"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Submit Request'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default DeveloperDocs;